import {
  useSpellingBeeReducer,
  SpellingBeeContext,
  SpellingBeeDispatchContext,
} from "app/spelling-bee/useSpellingBee";
import { STORAGE_KEY_PREFIX } from "app/utils/useResetableStorage";

interface SpellingBeeProviderProps {
  roundIndex: number;
  children: React.ReactNode;
}

export function SpellingBeeProvider(props: SpellingBeeProviderProps) {
  const [roundState, dispatch] = useSpellingBeeReducer(
    `${STORAGE_KEY_PREFIX}_SPELLING_BEE_ROUND_STATE_${props.roundIndex}`,
  );
  return (
    <SpellingBeeContext value={roundState}>
      <SpellingBeeDispatchContext value={dispatch}>
        {props.children}
      </SpellingBeeDispatchContext>
    </SpellingBeeContext>
  );
}
